export default __webpack_public_path__ + "static/media/SpaceMono-Bold.1553b1e1.ttf";